const COUNTRY_LIST = [
  {
    "domain": "farmrio.com",
    "iso_code": "AL",
    "name": "Albania",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "DZ",
    "name": "Algeria",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AD",
    "name": "Andorra",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AO",
    "name": "Angola",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AI",
    "name": "Anguilla",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AG",
    "name": "Antigua &amp; Barbuda",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AR",
    "name": "Argentina",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AM",
    "name": "Armenia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AW",
    "name": "Aruba",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AU",
    "name": "Australia",
    "popular": true,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "AT",
    "name": "Austria",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "AZ",
    "name": "Azerbaijan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BS",
    "name": "Bahamas",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BH",
    "name": "Bahrain",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BD",
    "name": "Bangladesh",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BB",
    "name": "Barbados",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BY",
    "name": "Belarus",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "BE",
    "name": "Belgium",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BZ",
    "name": "Belize",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BJ",
    "name": "Benin",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BM",
    "name": "Bermuda",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BT",
    "name": "Bhutan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com.bo",
    "iso_code": "BO",
    "name": "Bolivia",
    "autoRedirect": false,
    "siteName": "Bolivian",
    "popular": false,
    "unit_system": "metric",
    "availableLanguages": [
      {
        "iso_code": "es",
        "name": "Spanish",
        "primary": true,
        "root_url": "/",
        "endonym_name": "Español"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BA",
    "name": "Bosnia &amp; Herzegovina",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BW",
    "name": "Botswana",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BR",
    "name": "Brazil",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "VG",
    "name": "British Virgin Islands",
    "popular": false,
    "unit_system": "imperial",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BN",
    "name": "Brunei",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "BG",
    "name": "Bulgaria",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KH",
    "name": "Cambodia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "CA",
    "name": "Canada",
    "popular": true,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "CV",
    "name": "Cape Verde",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BQ",
    "name": "Caribbean Netherlands",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KY",
    "name": "Cayman Islands",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.cl",
    "iso_code": "CL",
    "name": "Chile",
    "autoRedirect": false,
    "siteName": "Chilean",
    "popular": false,
    "unit_system": "metric",
    "availableLanguages": [
      {
        "iso_code": "es",
        "name": "Spanish",
        "primary": true,
        "root_url": "/",
        "endonym_name": "Español"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "CN",
    "name": "China",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com.co",
    "iso_code": "CO",
    "name": "Colombia",
    "autoRedirect": false,
    "siteName": "Colombian",
    "popular": false,
    "unit_system": "metric",
    "availableLanguages": [
      {
        "iso_code": "es",
        "name": "Spanish",
        "primary": true,
        "root_url": "/",
        "endonym_name": "Español"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KM",
    "name": "Comoros",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "CK",
    "name": "Cook Islands",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "CR",
    "name": "Costa Rica",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "HR",
    "name": "Croatia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "CW",
    "name": "Curaçao",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "CY",
    "name": "Cyprus",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "CZ",
    "name": "Czechia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "DK",
    "name": "Denmark",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "DJ",
    "name": "Djibouti",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "DM",
    "name": "Dominica",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "DO",
    "name": "Dominican Republic",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com.ec",
    "iso_code": "EC",
    "name": "Ecuador",
    "autoRedirect": false,
    "siteName": "Ecuadorian",
    "popular": false,
    "unit_system": "metric",
    "availableLanguages": [
      {
        "iso_code": "es",
        "name": "Spanish",
        "primary": true,
        "root_url": "/",
        "endonym_name": "Español"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "EG",
    "name": "Egypt",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SV",
    "name": "El Salvador",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "EE",
    "name": "Estonia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SZ",
    "name": "Eswatini",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "ET",
    "name": "Ethiopia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "FK",
    "name": "Falkland Islands",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "FO",
    "name": "Faroe Islands",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "FJ",
    "name": "Fiji",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "FI",
    "name": "Finland",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "FR",
    "name": "France",
    "popular": true,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      },
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GF",
    "name": "French Guiana",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "PF",
    "name": "French Polynesia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GE",
    "name": "Georgia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "DE",
    "name": "Germany",
    "popular": true,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GI",
    "name": "Gibraltar",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "GR",
    "name": "Greece",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GL",
    "name": "Greenland",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GD",
    "name": "Grenada",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GP",
    "name": "Guadeloupe",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GT",
    "name": "Guatemala",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GG",
    "name": "Guernsey",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GN",
    "name": "Guinea",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GW",
    "name": "Guinea-Bissau",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "GY",
    "name": "Guyana",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "HT",
    "name": "Haiti",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "HN",
    "name": "Honduras",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "HK",
    "name": "Hong Kong SAR",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "HU",
    "name": "Hungary",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "IS",
    "name": "Iceland",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "IN",
    "name": "India",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "ID",
    "name": "Indonesia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "IE",
    "name": "Ireland",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "IM",
    "name": "Isle of Man",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "IT",
    "name": "Italy",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "JM",
    "name": "Jamaica",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "JP",
    "name": "Japan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "JE",
    "name": "Jersey",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "JO",
    "name": "Jordan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KZ",
    "name": "Kazakhstan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KE",
    "name": "Kenya",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KI",
    "name": "Kiribati",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KW",
    "name": "Kuwait",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KG",
    "name": "Kyrgyzstan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "LA",
    "name": "Laos",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "LV",
    "name": "Latvia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "LB",
    "name": "Lebanon",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "LS",
    "name": "Lesotho",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "LI",
    "name": "Liechtenstein",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "LT",
    "name": "Lithuania",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "LU",
    "name": "Luxembourg",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MO",
    "name": "Macao SAR",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MG",
    "name": "Madagascar",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MW",
    "name": "Malawi",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MY",
    "name": "Malaysia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MV",
    "name": "Maldives",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "MT",
    "name": "Malta",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MQ",
    "name": "Martinique",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MR",
    "name": "Mauritania",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MU",
    "name": "Mauritius",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MX",
    "name": "Mexico",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MD",
    "name": "Moldova",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MC",
    "name": "Monaco",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MN",
    "name": "Mongolia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "ME",
    "name": "Montenegro",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MS",
    "name": "Montserrat",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MA",
    "name": "Morocco",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MZ",
    "name": "Mozambique",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NA",
    "name": "Namibia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NR",
    "name": "Nauru",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NP",
    "name": "Nepal",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "NL",
    "name": "Netherlands",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NC",
    "name": "New Caledonia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NZ",
    "name": "New Zealand",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NI",
    "name": "Nicaragua",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NG",
    "name": "Nigeria",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NU",
    "name": "Niue",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MK",
    "name": "North Macedonia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "NO",
    "name": "Norway",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "OM",
    "name": "Oman",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "PK",
    "name": "Pakistan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com.pa",
    "iso_code": "PA",
    "name": "Panama",
    "autoRedirect": false,
    "siteName": "Panamanian",
    "popular": false,
    "unit_system": "metric",
    "availableLanguages": [
      {
        "iso_code": "es",
        "name": "Spanish",
        "primary": true,
        "root_url": "/",
        "endonym_name": "Español"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "PG",
    "name": "Papua New Guinea",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com.py",
    "iso_code": "PY",
    "name": "Paraguay",
    "autoRedirect": false,
    "siteName": "Paraguayan",
    "popular": false,
    "unit_system": "metric",
    "availableLanguages": [
      {
        "iso_code": "es",
        "name": "Spanish",
        "primary": true,
        "root_url": "/",
        "endonym_name": "Español"
      }
    ]
  },
  {
    "domain": "farmrio.com.pe",
    "iso_code": "PE",
    "name": "Peru",
    "autoRedirect": false,
    "siteName": "Peruvian",
    "popular": false,
    "unit_system": "metric",
    "availableLanguages": [
      {
        "iso_code": "es",
        "name": "Spanish",
        "primary": true,
        "root_url": "/",
        "endonym_name": "Español"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "PH",
    "name": "Philippines",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "PL",
    "name": "Poland",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "PT",
    "name": "Portugal",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "QA",
    "name": "Qatar",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "RO",
    "name": "Romania",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "RE",
    "name": "Réunion",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "WS",
    "name": "Samoa",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SM",
    "name": "San Marino",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SA",
    "name": "Saudi Arabia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SN",
    "name": "Senegal",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "RS",
    "name": "Serbia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SC",
    "name": "Seychelles",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SG",
    "name": "Singapore",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "SK",
    "name": "Slovakia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "SI",
    "name": "Slovenia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SB",
    "name": "Solomon Islands",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "ZA",
    "name": "South Africa",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KR",
    "name": "South Korea",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "ES",
    "name": "Spain",
    "popular": true,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "LK",
    "name": "Sri Lanka",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "BL",
    "name": "St. Barthélemy",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "KN",
    "name": "St. Kitts &amp; Nevis",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "LC",
    "name": "St. Lucia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "MF",
    "name": "St. Martin",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SD",
    "name": "Sudan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "SR",
    "name": "Suriname",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.eu",
    "iso_code": "SE",
    "name": "Sweden",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "fr",
        "name": "French",
        "primary": false,
        "root_url": "/fr",
        "endonym_name": "Français"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "CH",
    "name": "Switzerland",
    "popular": true,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "ST",
    "name": "São Tomé &amp; Príncipe",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TW",
    "name": "Taiwan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TZ",
    "name": "Tanzania",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TH",
    "name": "Thailand",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TL",
    "name": "Timor-Leste",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TO",
    "name": "Tonga",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TT",
    "name": "Trinidad &amp; Tobago",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TN",
    "name": "Tunisia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TM",
    "name": "Turkmenistan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TC",
    "name": "Turks &amp; Caicos Islands",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "TV",
    "name": "Tuvalu",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.ae",
    "iso_code": "AE",
    "name": "United Arab Emirates",
    "autoRedirect": true,
    "popular": false,
    "unit_system": "metric",
    "siteName": "Emirati",
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      },
      {
        "iso_code": "ar",
        "name": "Arabic",
        "primary": false,
        "root_url": "/ar",
        "endonym_name": "العربية"
      }
    ]
  },
  {
    "domain": "farmrio.uk",
    "iso_code": "GB",
    "name": "United Kingdom",
    "popular": true,
    "unit_system": "imperial",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "US",
    "name": "United States",
    "popular": true,
    "unit_system": "imperial",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com.uy",
    "iso_code": "UY",
    "name": "Uruguay",
    "autoRedirect": false,
    "siteName": "Uruguayan",
    "popular": false,
    "unit_system": "metric",
    "availableLanguages": [
      {
        "iso_code": "es",
        "name": "Spanish",
        "primary": true,
        "root_url": "/",
        "endonym_name": "Español"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "UZ",
    "name": "Uzbekistan",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "VU",
    "name": "Vanuatu",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "VA",
    "name": "Vatican City",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "VE",
    "name": "Venezuela",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "VN",
    "name": "Vietnam",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "WF",
    "name": "Wallis &amp; Futuna",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "ZM",
    "name": "Zambia",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  },
  {
    "domain": "farmrio.com",
    "iso_code": "ZW",
    "name": "Zimbabwe",
    "popular": false,
    "unit_system": "metric",
    "autoRedirect": false,
    "availableLanguages": [
      {
        "iso_code": "en",
        "name": "English",
        "primary": true,
        "root_url": "/",
        "endonym_name": "English"
      }
    ]
  }
];

async function getCountryInfo(isoCode) {
  let country;
  country = COUNTRY_LIST.find(country => country.iso_code === isoCode);
  return country;
}

async function suggestChangeCountry(visitCountry) {
  const $countryModal = document.querySelector(
    "#modal-user-location-recommendation"
  );

  if (!$countryModal) return;

  const countryInfo = await getCountryInfo(visitCountry);

  $countryModal.innerHTML = `
    <div class="cus-country-modal">
      <button class="closeButton">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="cus-country-modal__content">
        <p>It seems you are visiting us from ${countryInfo.name}. Would you like to be redirected to our ${countryInfo.name} site?</p>
      </div>
      <div class="cus-country-modal__buttons">
        <button>Stay on ${window.location.hostname}</button>
        <button>Ok, take me there</button>
      </div>
      <p><small>*Shipping costs and taxes may vary.</small></p>
    </div>
  `;
  
  const closeButton = $countryModal.querySelector(".closeButton");
  const stayOnCurrentSiteButton = $countryModal.querySelector(".cus-country-modal__buttons button:first-child");
  const redirectToCountryButton = $countryModal.querySelector(".cus-country-modal__buttons button:last-child");
  $countryModal.classList.remove("hidden");

  closeButton.addEventListener("click", () => {
    $countryModal.classList.add("hidden");
  });

  stayOnCurrentSiteButton.addEventListener("click", () => {
    $countryModal.classList.add("hidden");
  });

  redirectToCountryButton.addEventListener("click", () => {
    window.location.href = `https://${countryInfo.domain}`;
  });
}

async function changeCountryModal(visitCountry) {
  const $countryModal = document.querySelector(
    "#modal-user-location-recommendation"
  );

  if (!$countryModal) return;

  $countryModal.innerHTML = `
    <div class="cus-country-modal">
      <button class="closeButton">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="cus-country-modal__content">
        <p>Change Country/Region</p>
        <select>
          ${COUNTRY_LIST.map(country => `<option value="${country.iso_code}" ${country.iso_code === visitCountry ? "selected" : ""}>${country.name}</option>`).join("\n")}
        </select>
      </div>
      <div class="cus-country-modal__buttons">
        <button>Cancel</button>
        <button>Save</button>
      </div>
    </div>
  `;

  const closeButton = $countryModal.querySelector(".closeButton");
  const cancelButton = $countryModal.querySelector(".cus-country-modal__buttons button:first-child");
  const saveButton = $countryModal.querySelector(".cus-country-modal__buttons button:last-child");
  const select = $countryModal.querySelector(".cus-country-modal__content select");
  $countryModal.classList.remove("hidden");

  closeButton.addEventListener("click", () => {
    $countryModal.classList.add("hidden");
  });

  cancelButton.addEventListener("click", () => {
    $countryModal.classList.add("hidden");
  });
  
  saveButton.addEventListener("click", async () => {
    const selectedCountry = select.value;
    const countryInfo = await getCountryInfo(selectedCountry);
    window.location.href = `https://${countryInfo.domain}`;
  });
}

async function main() {
  const $countryButton = document.querySelector("#flag-country-icon-mx");
  const response = await fetch(
    window.Shopify.routes.root +
      "browsing_context_suggestions.json" +
      "?country[enabled]=true" +
      `&country[exclude]=${window.Shopify.country}` +
      "&language[enabled]=true" +
      `&language[exclude]=${window.Shopify.language}`
  ).then((r) => r.json());

  const visitCountry = response.detected_values.country.handle;

  if (visitCountry !== "MX") {
    suggestChangeCountry(visitCountry);
  }

  $countryButton.addEventListener("click", () => {
    changeCountryModal(visitCountry);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  main();
});
